export const IMPORT_STATUS = {
  LOADING: 'loading',
  FETCHING_PROJECTS: 'fetching projetcs',
  NO_ACTIVE: 'no active import',
  ACTIVE: 'active import exists'
};
